import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: 'mwp-dialog-logout',
    templateUrl: './logout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogLogoutComponent {

    constructor(
        private dialogRef: MatDialogRef<DialogLogoutComponent>,
        private authService: AuthService,
    ) {
    }

    logout(): void {
        this.authService.apiLogout().subscribe(() => {
        });
        this.authService.logout();
        this.dialogRef.close();
    }

    close(): void {
        this.dialogRef.close();
    }
}